// extracted by mini-css-extract-plugin
module.exports = {"containerRoadTaxModal":"styles_containerRoadTaxModal__38VAL","textLink":"styles_textLink__wd_Yo"};